import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { DocumentLevel } from 'providers/DocumentLevel';

export const Heading = ({ children, className, ...attrs }) => (
  <DocumentLevel.Consumer>
    {level => {
      const Tag = level > 6 ? 'p' : `h${level}`;
      const tagClass = classNames(className, level > 6 && `h${level}`);
      return (
        <Tag {...attrs} className={tagClass}>
          {children}
        </Tag>
      );
    }}
  </DocumentLevel.Consumer>
);

Heading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
